import styled from '@emotion/styled';
import rem from '../../../../utils/rem/rem';
import { StyledProps } from '../../../../components/MenuTreeView/MenuTreeView.types';

export const MenuExtractPage = styled.div`
  padding: 0 32px;
  display: flex;
  height: calc(100vh - 208px);
`;

export const TableRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-grow: 1;
  margin-bottom: ${rem(16)};
  gap: ${rem(16)} 32px;
  padding-top: ${rem(16)};

  @media ${({ theme }) => theme.breakpoints.lg} {
    flex-direction: column;
  }
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  gap: ${rem(30)} 10px;
  flex: 1;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  gap: ${rem(16)} 24px;
  aling-items: left;
  flex: 0.5;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  align-content: space-between;
  flex-direction: row;
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  border-left: 1px solid ${({ theme }) => theme.colors.gray400};
  border-right: 1px solid ${({ theme }) => theme.colors.gray400};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  @media only screen and ${({ theme }) => theme.breakpoints.xl} {
    flex-direction: column;
  }
`;

export const HeaderInputButton = styled.span`
  padding: 6px 16px 10px 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  button:first-of-type {
    margin: 0;
    margin-top: ${rem(10)};
  }
  
`;

export const StyledSubTitle = styled.div<StyledProps>`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: ${rem(16)};
  margin: 16px;
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const StyledSubHeader = styled.div<StyledProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.gray100};
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  border-left: 1px solid ${({ theme }) => theme.colors.gray400};
  border-right: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: ${({ borderRadius }) => `${borderRadius === undefined ? 0 : borderRadius}px`};
`;

export const TableWrapper = styled.div`
  width: calc(50vw - 232px);
  min-width: ${rem(396)};
  height: 100%;

  @media ${({ theme }) => theme.breakpoints.lg} {
    width: 100%;
  }
`;

export const TreeViewRowWrapper = styled.div`
  width: calc(50vw - 232px);
  min-width: ${rem(396)};
  height: 100%;

  @media ${({ theme }) => theme.breakpoints.lg} {
    width: 100%;
  }
`;

export const Buttons = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.gray400};
  padding-left: 32px;
  margin-left: 32px;
`;
